// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/checkmark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/checkmark_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColumnsSettingsSelect__radioLabel:hover,
.DiscountSettingsSelect__radioLabel:hover, .ColumnsSettingsSelect__totalsRadio:hover,
.DiscountSettingsSelect__totalsRadio:hover, .ColumnsSettingsSelect__option:hover,
.DiscountSettingsSelect__option:hover {
  cursor: pointer;
}

.ColumnsSettingsSelect .select-menu,
.DiscountSettingsSelect .select-menu {
  max-height: 300px !important;
}
.ColumnsSettingsSelect__list,
.DiscountSettingsSelect__list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.ColumnsSettingsSelect__option,
.DiscountSettingsSelect__option {
  display: block;
  padding: 4px 6px 4px 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ColumnsSettingsSelect__option--selected,
.DiscountSettingsSelect__option--selected {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) left 10px center no-repeat;
  background-size: 10px;
}
.ColumnsSettingsSelect__option--selected:hover,
.DiscountSettingsSelect__option--selected:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) left 10px center no-repeat;
  background-size: 10px;
}
.ColumnsSettingsSelect__option:hover,
.DiscountSettingsSelect__option:hover {
  background-color: #F5F6F9;
}
.ColumnsSettingsSelect__optionsTitle,
.DiscountSettingsSelect__optionsTitle {
  color: #002E33;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
  padding: 10px 0 10px 10px;
  border-top: #E8E9F0 1px solid;
  margin-top: 5px;
  display: block;
}
.ColumnsSettingsSelect__totalsRadio,
.DiscountSettingsSelect__totalsRadio {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 4px 6px;
}
.ColumnsSettingsSelect__totalsRadio:hover,
.DiscountSettingsSelect__totalsRadio:hover {
  background-color: #F5F6F9;
}
.ColumnsSettingsSelect__radioLabel,
.DiscountSettingsSelect__radioLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ColumnsSettingsSelect__radioCheck,
.DiscountSettingsSelect__radioCheck {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #E8E9F0;
  background: #FFF;
  padding: 0;
  margin-right: 6px;
  border-radius: 50%;
  vertical-align: middle;
}
.ColumnsSettingsSelect__radioCheck--checked,
.DiscountSettingsSelect__radioCheck--checked {
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
  border: 1px solid #01FF94;
  background-size: 8px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/MyAccount/views/InvoiceEstimateSettings/ColumnsSettings/ColumnsSettings.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGE;;;;EACE,eAAA;AACJ;;AAKE;;EACE,4BAAA;AADJ;AAIE;;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AADJ;AAIE;;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;;EACE,8EAAA;EACA,qBAAA;AAAN;AAEM;;EACE,8EAAA;EACA,qBAAA;AACR;AAKI;;EACE,yBCkBG;ADpBT;AAME;;EACE,cC3CW;ED4CX,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;AAHJ;AAME;;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,gBAAA;AAHJ;AAOI;;EACE,yBCJG;ADAT;AAQE;;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAWE;;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBCxEI;EDyEJ,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AARJ;AAUI;;EACE,4EAAA;EACA,yBAAA;EACA,oBAAA;AAPN","sourcesContent":["@import \"../../../../../Global/Colors.scss\";\n\n%hover-cursor-pointer {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.ColumnsSettingsSelect,\n.DiscountSettingsSelect {\n  .select-menu {\n    max-height: 300px !important;\n  }\n\n  &__list {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  &__option {\n    display: block;\n    padding: 4px 6px 4px 30px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &--selected {\n      background: url('~images/checkmark.svg') left 10px center no-repeat;\n      background-size: 10px;\n\n      &:hover {\n        background: url('~images/checkmark_deepSeaGreen.svg') left 10px center no-repeat;\n        background-size: 10px;\n      }\n    }\n\n    @extend %hover-cursor-pointer;\n\n    &:hover {\n      background-color: $Gray20;\n    }\n  }\n\n  &__optionsTitle {\n    color: $DeepSeaGreen;\n    text-transform: uppercase;\n    font-size: 10px;\n    font-weight: 700;\n    padding: 10px 0 10px 10px;\n    border-top: $Gray30 1px solid;\n    margin-top: 5px;\n    display: block;\n  }\n\n  &__totalsRadio {\n    display: flex;\n    padding: 4px 6px;\n\n    @extend %hover-cursor-pointer;\n\n    &:hover {\n      background-color: $Gray20;\n    }\n  }\n\n  &__radioLabel {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n\n    @extend %hover-cursor-pointer;\n  }\n\n  &__radioCheck {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border: 1px solid $Gray30;\n    background: $White;\n    padding: 0;\n    margin-right: 6px;\n    border-radius: 50%;\n    vertical-align: middle;\n\n    &--checked {\n      background: $ElectricGreen url('~images/checkmark_deepSeaGreen.svg') center no-repeat;\n      border: 1px solid $ElectricGreen;\n      background-size: 8px;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
